// extracted by mini-css-extract-plugin
export default {"text":"Timer_text__wcsIq","animation":"Timer_animation__OKOsi"};